import React, { useState } from "react";
import InputText from "../common/InputText";
import { useComponent } from "../common/Modal";
import { ClipLoader } from "react-spinners";
import { useForm } from "react-hook-form";
import { forgotPassword, userSignup } from "../../services/apiServices";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
const ForgotPassword = () => {
  const { setCurrentComponent,onClose } = useComponent();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    trigger,
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const payload = {
        email: data?.email?.toLowerCase(),
      };
      const response = await forgotPassword(payload);
      if (response?.data?.statusCode == 200) {
        toast.success(
          response?.data?.message || t("forgot_success"),
          {
            position: "top-right",
            autoClose: 4000,
          }
        );
        onClose(setCurrentComponent,"signIn")
        reset();
      } else {
        toast.error(
          response?.data?.message || t("forgot_failed"),
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
      }
    } catch (error) {
      console.warn("error coming in forgot password: ", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <h2 className="text-2xl text-primary-text font-semibold text-center">
        {t("forgot_title")}
      </h2>

      <h5 className="text-center mt-2 text-lg text-[#5D5D5D] font-medium">
        {t("forgot_subtitle")}
      </h5>
      <form onSubmit={handleSubmit(onSubmit)}>
        <InputText
          title={t("forgot_email")}
          placeholder={t("forgot_email_placeholder")}
          type="email"
          {...register("email", {
            required: t("forgot_email_required"),
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: t("forgot_email_invalid"),
            },
          })}
          error={errors.email?.message}
          value={watch("email")}
          onChange={(e) => {
            setValue("email", e.target.value);
            trigger("email");
          }}
        />

        <div className="mt-6 text-center">
          <button
            className="w-full text-base bg-red-600 text-white p-3 rounded-[121px] font-semibold"
            disabled={loading}
          >
            {loading ? <ClipLoader size={20} color="#fff" /> : t("forgot_continue")}
          </button>

          <button
            onClick={() => setCurrentComponent("signIn")}
            className="text-[#5D5D5D] text-base text-center mt-6 font-semibold"
            type="button"
          >
            {t("forgot_back")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;
